import { websiteBuilderGenerateDefaultButton } from "../../element/websiteBuilderButton";
import { websiteBuilderGenerateDefaultHeading } from "../../element/websiteBuilderHeading";
import { websiteBuilderGenerateDefaultParagraph } from "../../element/websiteBuilderParagraph";
import { IWebsiteBuilderMediaItem } from "redux/reducers/models/websiteBuilder";
import { IWebsiteBuilderContent, websiteBuilderGenerateDefaultContent } from "../websiteBuilderContent";
import { websiteBuilderSetTemplateSectionBackgroundImage } from "./websiteBuilderResolveTemplateMedia";

export function websiteBuilderHeroTemplate(media: IWebsiteBuilderMediaItem[]): IWebsiteBuilderContent {
  const section = websiteBuilderGenerateDefaultContent();
  const subHeading = websiteBuilderGenerateDefaultParagraph();
  const heading = websiteBuilderGenerateDefaultHeading();
  const paragraph = websiteBuilderGenerateDefaultParagraph();
  const button = websiteBuilderGenerateDefaultButton();

  section.section.background.color = "#000000";
  websiteBuilderSetTemplateSectionBackgroundImage(section, media, "allan-nygren");

  section.section.layout.desktop.height = 730;
  section.section.layout.tablet.height = 530;
  section.section.layout.mobile.height = 520;

  subHeading.element.layout.desktop.position = { x: 128, y: 263 };
  subHeading.element.layout.tablet.position = { x: 72, y: 163 };
  subHeading.element.layout.mobile.position = { x: 25, y: 103 };
  subHeading.element.layout.desktop.dimensions = { width: 300, height: 25 };
  subHeading.element.layout.tablet.dimensions = { width: 300, height: 25 };
  subHeading.element.layout.mobile.dimensions = { width: 270, height: 25 };
  subHeading.element.settings.content = {
    type: "doc",
    attrs: {
      responsiveFontSize: {
        desktop: "12px",
        tablet: "12px",
        mobile: "12px",
      },
    },
    content: [{
      type: "paragraph",
      content: [{
        type: "text",
        text: "WELCOME TO RIVERDALE GOLF", // TODO: Translation
        marks: [{
          type: "textStyle",
          attrs: {
            color: "#FFFFFF",
          },
        }],
      }],
    }],
  };

  heading.element.layout.desktop.position = { x: 128, y: 298 };
  heading.element.layout.tablet.position = { x: 72, y: 198 };
  heading.element.layout.mobile.position = { x: 25, y: 138 };
  heading.element.layout.desktop.dimensions = { width: 710, height: 60 };
  heading.element.layout.tablet.dimensions = { width: 624, height: 60 };
  heading.element.layout.mobile.dimensions = { width: 270, height: 140 };
  heading.element.settings.content = {
    type: "doc",
    attrs: {
      responsiveFontSize: {
        desktop: "48px",
        tablet: "42px",
        mobile: "36px",
      },
    },
    content: [{
      type: "heading",
      attrs: { level: 1, lineHeight: "1.2" },
      content: [{
        type: "text",
        text: "Your perfect round starts here.", // TODO: Translation
        marks: [{
          type: "textStyle",
          attrs: {
            color: "#FFFFFF",
          },
        }],
      }],
    }],
  };

  paragraph.element.layout.desktop.position = { x: 128, y: 368 };
  paragraph.element.layout.tablet.position = { x: 72, y: 268 };
  paragraph.element.layout.mobile.position = { x: 25, y: 293 };
  paragraph.element.layout.desktop.dimensions = { width: 650, height: 35 };
  paragraph.element.layout.tablet.dimensions = { width: 624, height: 35 };
  paragraph.element.layout.mobile.dimensions = { width: 270, height: 60 };
  paragraph.element.settings.content = {
    type: "doc",
    attrs: {
      responsiveFontSize: {
        desktop: "20px",
        tablet: "18px",
        mobile: "16px",
      },
    },
    content: [{
      type: "paragraph",
      content: [{
        type: "text",
        text: "Experience our championship course and exceptional hospitality.", // TODO: Translation
        marks: [{
          type: "textStyle",
          attrs: {
            color: "#FFFFFF",
          },
        }],
      }],
    }],
  };

  button.element.layout.desktop.position = { x: 128, y: 423 };
  button.element.layout.tablet.position = { x: 72, y: 323 };
  button.element.layout.mobile.position = { x: 25, y: 373 };
  button.element.layout.desktop.dimensions = { width: 160, height: 44 };
  button.element.layout.tablet.dimensions = { width: 160, height: 44 };
  button.element.layout.mobile.dimensions = { width: 160, height: 44 };
  button.element.settings.type = "secondary";
  button.element.settings.label = "Book a tee time"; // TODO: Translation
  button.element.settings.borderRadius = 10;

  section.children = [subHeading, heading, paragraph, button];

  return section;
}
